import { dom } from '@Engage.Core';
export class Mask {
    constructor(maskingOptions) {
        this.styleElementClass = 'content-styles';
        this.elementToBeMaskedClass = 'to-be-masked';
        this.exceptionContentStylesSelectors = ['.blurry-text', '.mark-text', '.Mg2-fade'];
        this.maskingOptions = maskingOptions;
        const excludedClassesStr = this.maskingOptions.ExcludeClasses.join(' .') ? '.' + this.maskingOptions.ExcludeClasses.join(' .') : '';
        this.maskElement = dom.queryElement(this.maskingOptions.Selector + `:not(${excludedClassesStr})`);
        if (!this.maskElement)
            return;
        this.maskElement.classList.add(this.elementToBeMaskedClass);
        this.setOriginalContent();
        this.setContentStyles();
    }
    setOriginalContent() {
        const deepClonnedElement = this.maskElement.cloneNode(true);
        this.getExcludedElements(deepClonnedElement).forEach((currentElement) => {
            currentElement.remove();
        });
        this.originalContent = dom.removeScripts(deepClonnedElement.innerHTML);
    }
    setContentStyles() {
        const selectedElement = dom.queryElement(this.maskingOptions.Selector + `.${this.elementToBeMaskedClass}`);
        const existedStyleElement = dom.find('.' + this.styleElementClass, selectedElement);
        let selector = `${this.maskingOptions.Selector}.${this.elementToBeMaskedClass} *`;
        this.exceptionContentStylesSelectors.forEach((exceptionSelector) => selector += `:not(${exceptionSelector})`);
        const html = `
            ${selector}, ${selector}:before, ${selector}:after {
               height: inherit;
               padding: 0px;
               content: '';
            }
        `;
        if (existedStyleElement[0]) {
            this.styleElement = existedStyleElement[0];
        }
        else {
            this.styleElement = dom.createElement('style');
            dom.addClass(this.styleElement, this.styleElementClass);
            selectedElement.append(this.styleElement);
        }
        dom.html(this.styleElement, html);
    }
    getOriginalContent() {
        return this.originalContent;
    }
    getMaskElement() {
        return this.maskElement;
    }
    // for the unit tests
    getMaskHtml() {
        return dom.queryElement(this.maskingOptions.Selector).innerHTML;
    }
    removeHeightFromContent() {
        dom.css(this.getMaskElement(), {
            'text-overflow': 'ellipsis',
            'overflow': 'hidden',
            'height': 'auto',
            'min-height': 'unset'
        });
    }
    unMask() {
        dom.queryElement(this.maskingOptions.Selector).innerHTML = this.getOriginalContent();
    }
    findNextElement(element) {
        return element.nextElementSibling;
    }
    isExcludeElement(element) {
        let excludeClasses = this.getExcludedClasses();
        if (excludeClasses && Array.isArray(excludeClasses)) {
            let countClasses = excludeClasses.length;
            for (let i = 0; i < countClasses; i++) {
                if (dom.hasClass(element, excludeClasses[i])) {
                    return true;
                }
            }
        }
        return false;
    }
    isElementHasExcludes(element) {
        let excludeClasses = this.getExcludedClasses();
        let countClasses = excludeClasses.length;
        for (let i = 0; i < countClasses; i++) {
            let excludeElements = dom.find('.' + excludeClasses[i], element);
            if (excludeElements && excludeElements.length > 0) {
                return true;
            }
        }
        return false;
    }
    getExcludedElements(element) {
        let elementsNeedExclude = [];
        this.getExcludedClasses().forEach((excludeClass) => {
            let finded = dom.find('.' + excludeClass, element);
            elementsNeedExclude = elementsNeedExclude.concat(finded);
        });
        return elementsNeedExclude;
    }
    calculateExcludesHeight(element) {
        let excludeElements = this.getExcludedElements(element);
        let sumHeight = 0;
        excludeElements.forEach((excludeElement) => {
            sumHeight += sumHeight + dom.height(excludeElement);
        });
        return sumHeight;
    }
    getExcludedClasses() {
        let excludeClasses = this.maskingOptions.ExcludeClasses ? [...this.maskingOptions.ExcludeClasses] : [];
        excludeClasses.push(this.styleElementClass);
        return excludeClasses;
    }
}
